import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import '../../styles/theme.css';

const NotFound = () => {
  return (
    <>
      <Helmet>
        <title>404 - Page Not Found | OptiBill Analytics</title>
        <meta name="description" content="The page you're looking for doesn't exist. Return to OptiBill Analytics homepage." />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      
      <div className="status-page">
        <div className="status-card">
          <h1 className="status-code">404</h1>
          <h2 className="text-navy fw-bold" style={{ fontSize: 32, marginBottom: 16 }}>Page Not Found</h2>
          <p className="page-subtitle" style={{ marginBottom: 24 }}>
            The page you requested is unavailable or may have moved to a different location.
          </p>
          <Link to="/" className="about-btn">Back to Home</Link>
          <div className="pill-cloud" style={{ marginTop: 20 }}>
            <Link to="/about" className="pill-item">About</Link>
            <Link to="/services" className="pill-item">Services</Link>
            <Link to="/contact" className="pill-item">Contact</Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;
